import React, { useState } from "react";
import Axios from "axios";
import { useHistory } from "react-router-dom";
import validateLogin from "./ValidateLoginForm";
import logo from "../../assets/images/delsuLogo.jpg";
import Loader from "./Loader";

const Login = () => {
    localStorage.removeItem("successfulReservationToken");
    const [open, setOpen] = useState(false);
    let history = useHistory();
    const [formErrors, setFormErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState("");
    const [loginDetails, setLoginDetails] = useState({
        Username: "",
        Password: ""
    });
    const handleOnChange = (event) => {
        event.preventDefault();
        setLoginDetails({ ...loginDetails, [event.target.name]: event.target.value });
    }

    const authorize = (data) => {
        let session = data.expireTime;
        let expireTime = new Date(session).getTime();
        if (data.role === "Administrative Staff") {
            localStorage.setItem("adminToken", data.token);
            localStorage.setItem("adminExpireTimeToken", expireTime);
            history.push("/setupService");
        }
        else {
            localStorage.setItem("userId", data.userId);
            localStorage.setItem("staffToken", data.token);
            localStorage.setItem("staffExpireTimeToken", expireTime);
            localStorage.setItem("location", data.location);
            localStorage.setItem("username", data.username);
            history.push("/serviceQueue");
        }

    }


    const handleClose = () => {
        setOpen(false);
    };
    const handleToggle = () => {
        setOpen(!open);
    };

    const handleOnSubmit = (event) => {
        event.preventDefault();
        setFormErrors(validateLogin(loginDetails));
        if (validateLogin(loginDetails).isValidated) {
            handleToggle();
            Axios.post(process.env.REACT_APP_BASEURL + process.env.REACT_APP_AUTHENTICATION_URL, loginDetails)
                .then(res => {
                    console.log(res);
                    setErrorMessage("");
                    handleClose();
                    if (res.data.isSuccess) {
                        authorize(res.data);
                    }
                    else {
                        setErrorMessage("Wrong Username or Password!!!");
                    }
                })
                .catch(err => {
                    handleClose();
                    setErrorMessage("Check Internet Connection!!!");
                });
        }


    }
    return (

        <div className="login-wrapper">
            <div className="login-inner-wrapper">
                <div className="login-header">
                    <img src={logo} alt="delsu logo" className="login-img" />
                    <h1>Delta State University</h1>
                    <p>Login Portal</p>
                </div>
                <div className="login-details-wrapper">
                    <div className="login-error-message-wrapper">
                        <p>{errorMessage}</p>
                    </div>
                    <div className="">
                        <input type="text"
                            name="Username"
                            className="login-input"
                            placeholder="Username"
                            onChange={handleOnChange}
                            autocomplete="off"
                        />
                        <p className="error">{formErrors.username}</p>
                    </div>

                    <div>
                        <input
                            type="password"
                            name="Password"
                            className="login-input"
                            placeholder="Password"
                            onChange={handleOnChange}
                            autocomplete="off"
                        />
                        <p className="error">{formErrors.password}</p>
                    </div>
                    <div>
                        <button
                            className="login-btn"
                            onClick={handleOnSubmit}
                        >
                            Login
                        </button>
                    </div>
                    <a href="/forgot-password">Forgot Password?</a>
                </div>
            </div>
            <Loader state={open} />
        </div>
    )
}

export default Login;